import router from '@/router'
import { notification } from 'ant-design-vue'
import apiClient from '@/services/axios'
import VueCookies from 'vue-cookies'

export default {
  namespaced: true,
  state: {
    id: '',
    name: '',
    role: '',
    email: '',
    avatar: '',
    authorized: false,
    loading: false,
    accountFetchIsTouched: false,
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
  },
  actions: {
    async LOGIN({ commit, dispatch, rootState }, { email, password }) {
      try {
        const { data:{result} } = await apiClient.post('/auth/login', {
          email,
          password,
        })
        console.log(result, '<<<<<STORE USER')
        const dataUser = {
          user: {
            id: result.user.id,
            name: result.user.name,
            role: result.user.role,
            email: result.user.email,
            accessToken: result.token,
          },
          sessionId: result.token,
        }
        localStorage.setItem('userData', JSON.stringify(dataUser))
        return new Promise((resolve, reject) => {
          resolve({ user: dataUser.user, session: result.token })
        })
      } catch (err) {
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async LOAD_CURRENT_ACCOUNT({ commit, dispatch, rootState }, { token }) {
      try {
        const outerData = await apiClient.get('/users/load?token=' + token)
        // console.log(outerData,'<<<<<SAJDNLK:LNKJLS')
        if (!outerData.data.result.userData) router.push('/masuk')
        // console.log(outerData, 'outerData')
        const user = outerData.data.result.userData
        console.log(user, 'user')
        commit('SET_STATE', {
          name: user.username,
          email: user.email,
          sessionId: token,
          id: user.id,
          role: user.role,
        })
        VueCookies.set(
          'user',
          { id: user.id, email: user.email, name: user.username, role: user.role },
          null,
          '/',
        )
        // return new Promise((resolve, reject) => {
        //   // resolve({})
        // })
      } catch (err) {
        // router.push('/masuk')
        return new Promise((resolve, reject) => {
          reject(err)
        })
      }
    },
    async LOGOUT({ commit, rootState }) {
      try {
        // await apiClient.post('/account/logout')
        VueCookies.remove('sessionId')
        VueCookies.remove('user')
        localStorage.clear()
        commit('SET_STATE', { sessionId: null })
        router.push({ name: 'masuk' })
      } catch (err) {
        console.log(err)
      }
    },
  },
  getters: {
    user: state => state,
  },
}
